export default {
  permission: {
    changeLangState: true,
    changeThemeState: true,
    sendFormState: true,
    addToWatchedState: true,
    addToWatchlistState: true,
  },
};
